import { Link } from "react-router-dom";
import { CONTACT_EMAIL, LOCATION } from "@/lib/brand";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-bg-ink text-bg-base/90"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 border-t border-white/10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[12.5px]">
          {/* Left: links */}
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-1.5">
            {LINKS.map((l, i) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="hover:text-brand-red transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          {/* Right: contact */}
          <div className="flex flex-wrap items-center gap-x-5 gap-y-1.5">
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email"
              className="hover:text-brand-red transition-colors"
            >
              {CONTACT_EMAIL}
            </a>
            <span aria-hidden className="text-bg-base/30">·</span>
            <span data-testid="footer-location">{LOCATION}</span>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-[11.5px] text-bg-base/60">
          <span>© {year} ETradingGroup. All rights reserved.</span>
          <span className="tracking-[0.22em] uppercase">
            Reimagine how business works.
          </span>
        </div>
      </div>
    </footer>
  );
}
